import { Type } from '@sinclair/typebox';
// GET /settings/branding — returned to any authenticated caller (admin, hub
// root page, every track frontend) so the shared header can resolve the
// company logo. The image bytes themselves live behind GET /settings/logo;
// the URL here already includes the etag as a cache-busting query string.
export const SettingsBrandingResponseSchema = Type.Object({
    logoUrl: Type.Union([Type.String(), Type.Null()]),
    logoEtag: Type.Union([Type.String(), Type.Null()]),
    logoMime: Type.Union([Type.String(), Type.Null()]),
    // The hub's APP_BASE_URL — the origin of the admin SPA / portal. The shared
    // header builds its portal + Admin links from this; null when unset.
    appBaseUrl: Type.Union([Type.String(), Type.Null()]),
});
//# sourceMappingURL=settings.js.map